<div class="body-padding-start-window">
  @if (isEmailVerificationNeeded) {
    <div class="form-container" id="login-form-container">
      <div class="flex">
        <div (keyup.enter)="logIn()" class="w-full mx-auto">
          <span class="special-font font-bold text-xl">Login</span>
          <form [formGroup]="registrationForm" id="login-registration-form">
            <div class="mb-e mt-5">
              <label for="login-email-input" class="block mt-2 mb-1 text-sm font-medium text-gray-900 ">Email</label>
              <input id="login-email-input"
                     formControlName="email"
                     type="email"
                     autocomplete="email"
                     class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#faca15] focus:border-[#faca15] block w-full p-2.5  "
                     placeholder="name@company.com" required>
              @if (isInvalidAndTouched('email')) {
                <div class="flex gap-2 text-xs pt-2 text-red-500" id="login-email-error">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['email'].errors?.['required']) {
                    <span>Email is required.</span>
                  }
                  @if (registrationForm.controls['email'].errors?.['pattern']) {
                    <span>Email format is invalid.</span>
                  }
                </div>
              }
            </div>
            <div class="mb-5">
              <label for="login-password-input"
                     class="block mt-2 mb-1 text-sm font-medium text-gray-900 ">Password</label>
              <div class="relative w-full">
                <input id="login-password-input"
                       formControlName="password"
                       [type]="!isPasswordShown ? 'password' : 'text'"
                       placeholder="*********************"
                       autocomplete="current-password"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#faca15] focus:border-[#faca15] block w-full p-2.5  dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       required>
                <button (click)="toggleShowPassword()" type="button" id="login-show-password-btn"
                        class="absolute top-0 end-0 p-2.5 h-full text-sm font-medium text-white bg-[#FDDE64] rounded-e-lg border border-[#FDDE64] hover:bg-[#FDDE64]">
                  @if (isPasswordShown) {
                    <svg height="20" viewBox="0 0 48 48" width="20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h48v48h-48z" fill="none"/>
                      <path
                        d="M24 9c-10 0-18.54 6.22-22 15 3.46 8.78 12 15 22 15 10.01 0 18.54-6.22 22-15-3.46-8.78-11.99-15-22-15zm0 25c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10zm0-16c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>
                    </svg>
                  } @else {
                    <svg height="20" viewBox="0 0 48 48" width="20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48z" fill="none"/>
                      <path
                        d="M24 14c5.52 0 10 4.48 10 10 0 1.29-.26 2.52-.71 3.65l5.85 5.85c3.02-2.52 5.4-5.78 6.87-9.5-3.47-8.78-12-15-22.01-15-2.8 0-5.48.5-7.97 1.4l4.32 4.31c1.13-.44 2.36-.71 3.65-.71zm-20-5.45l4.56 4.56.91.91c-3.3 2.58-5.91 6.01-7.47 9.98 3.46 8.78 12 15 22 15 3.1 0 6.06-.6 8.77-1.69l.85.85 5.83 5.84 2.55-2.54-35.45-35.46-2.55 2.55zm11.06 11.05l3.09 3.09c-.09.43-.15.86-.15 1.31 0 3.31 2.69 6 6 6 .45 0 .88-.06 1.3-.15l3.09 3.09c-1.33.66-2.81 1.06-4.39 1.06-5.52 0-10-4.48-10-10 0-1.58.4-3.06 1.06-4.4zm8.61-1.57l6.3 6.3.03-.33c0-3.31-2.69-6-6-6l-.33.03z"/>
                    </svg>
                  }
                </button>
              </div>
              @if (isInvalidAndTouched('password')) {
                <div class="flex gap-2 text-xs pt-2 text-red-500" id="login-password-error">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['password'].errors?.['required']) {
                    <span>Password is required.</span>
                  }
                  @if (registrationForm.controls['password'].errors?.['pattern']) {
                    <span>Password is invalid.</span>
                  }
                </div>
              }
            </div>
          </form>
          <div class="flex justify-between align-baseline">
            <div class="flex items-center mb-4">
              <input [(ngModel)]="isRememberMeChecked" id="login-remember-me-checkbox" type="checkbox" value=""
                     class="w-4 h-4 border-gray-300 rounded">
              <label for="login-remember-me-checkbox" class="ms-2 text-sm font-normal text-gray-900 dark:text-gray-300">Remember
                me</label>
            </div>
            <div><a class="text-[#5D59FF] text-sm focus:text-[#2f22f0]" [routerLink]="['/forgot-password']"
                    id="login-forgot-password-link">Forgot your
              password?</a></div>
          </div>
          <button (click)="logIn()" (keyup.enter)="logIn()" type="button" id="login-submit-btn"
                  class="submit-button-forms">
            <div class="flex justify-center align-baseline">
              @if (isTokenSet()) {
                <div role="status" class="pr-2">
                  <svg aria-hidden="true" class="w-4 h-4 text-red-200 animate-spin dark:text-gray-600 fill-red-600"
                       viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"/>
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"/>
                  </svg>
                </div>
              }
              <div>Login</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="form-container" id="login-verification-container">
      <div class="flex">
        <div class="w-full mx-auto">
          <span class="special-font font-bold text-xl">Please verify your email</span>
          <div class="mt-5">
            <p class="text-base font-normal text-black ">We sent an email to <span
              class="whitespace-nowrap text-blue-500 ">{{ registeredEmail }}</span>.<br>
              Please click on the link in that email to proceed with your account registration.<br>
              If you don't see it, you may need to check your spam folder.
              Or <a (click)="resendVerification()" id="login-resend-verification-btn"
                    class="text-blue-500 underline cursor-pointer">resend the verification
                email.</a></p>
          </div>
        </div>
      </div>
    </div>
  }
</div>
